import $ from "jquery";
import {getDate, setMaxDate, setMinDate, setUIOptions, refreshCurrent, setDate} from "./datepicker";
import {dateToISOString, localDateToUTCDate} from "../libs/@elements/date-utils";
import {translate} from "../libs/@elements/translations";

let HOUR_IN_MS = 60 * 60 * 1000;
let DAY_IN_MS = 24 * HOUR_IN_MS;
let MIN_DURATION_DAYS = 29;
let MIN_DURATION = MIN_DURATION_DAYS * DAY_IN_MS;
let MAX_DURATION_DAYS = 364;
let MAX_DURATION = MAX_DURATION_DAYS * DAY_IN_MS;
let MIN_DATE = false;
/*const START_DAYS_IN_FUTURE_DAYS = _config.startDaysInFuture;
const START_DAYS_IN_FUTURE = START_DAYS_IN_FUTURE_DAYS * DAY_IN_MS;*/

export function initInScope($scope) {
    return $scope.find('.js-datepicker-range').each(function () {
        MIN_DURATION_DAYS = $(this).data('datepicker-min-duration-days') || 29;
        MIN_DURATION = MIN_DURATION_DAYS * DAY_IN_MS;
        MAX_DURATION_DAYS = $(this).data('datepicker-max-duration-days') || 364;
        MAX_DURATION = MAX_DURATION_DAYS * DAY_IN_MS;

        if($(this).data('datepicker-min-date')) {
            let MIN_DATE_DAYS = $(this).data('datepicker-min-date');
            let MIN_DATE = MIN_DATE_DAYS * DAY_IN_MS;
        }

        let $from = $(this).find('.js-datepicker-range__from');

        let $to = $(this).find('.js-datepicker-range__to');
        let $fromAlt = $(this).find('.js-datepicker__alt-field--from');
        let $toAlt = $(this).find('.js-datepicker__alt-field--to');

        let hasAvailabilities = $(this).hasClass('js-datepicker-range--with-availabilities');
        let hasDynamicAvailabilities = $(this).hasClass('js-datepicker-range--with-dynamic-availabilities');
        let url = $(this).data('datepicker-range-availabilities-url');

        let from = getDate($from);
        let fromAltDate = null;
        let to = getDate($to);
        let toAltDate = null;

        let loadedFrom = null;
        let loadedTo = null;
        // let availabilities = {};
        let availabilitiesFrom = {};
        let availabilitiesTo = {};

        if (from) {
            setMinDate($to, new Date(from.getTime() + MIN_DURATION));
            setMaxDate($to, new Date(from.getTime() + MAX_DURATION));
        }

        if($(this).data('datepicker-min-date')) {
            setMinDate($from, roundDay(new Date(from.getTime() + MIN_DATE)));
        }

        //setMinDate($from, new Date(from.getTime() + START_DAYS_IN_FUTURE));

        $from.on('change', function () {
            from = getDate($from);

            if (hasAvailabilities) {
                if (to) {
                    if (!isValidRange({from, to, availabilities: availabilitiesTo})) {
                        to = roundDay(new Date(from.getTime() + MIN_DURATION));
                        setDate($to, to);
                    }
                }

                setMaxDate($to, calculateMaxToDate({from, availabilities: availabilitiesTo}));
            } else {
                setMaxDate($to, roundDay(new Date(from.getTime() + MAX_DURATION)));

                /*let currentDate = getDate($toAlt);
                if(typeof currentDate === 'undefined') {
                    toAltDate = dateToISOString(new Date(from.getTime() + MAX_DURATION));
                    $toAlt.val(toAltDate);
                }*/
            }

            setMinDate($to, roundDay(new Date(from.getTime() + MIN_DURATION)));

            /*let currentDate = getDate($toAlt);
            if(typeof currentDate === 'undefined') {
                toAltDate = dateToISOString(new Date(from.getTime() + MIN_DURATION));
                $toAlt.val(toAltDate);
            }*/
        });

        $to.on('change', function () {
            to = getDate($to);

            if (hasDynamicAvailabilities) {
                $(this).closest('form').find('button').removeClass('disabled no-pointer')
            }
        });

        onAvailabilityChange();

        function onAvailabilityChange () {
            if (hasAvailabilities) {
                if (from) {
                    loadMonthIfNeeded({year: from.getUTCFullYear(), month: from.getUTCMonth()});
                }

                setUIOptions($from, {
                    onChangeMonthYear: function (year, month) {
                        loadMonthIfNeeded({year, month});
                    },
                    beforeShowDay: function (date) {
                        date = localDateToUTCDate(date);
                        // not available

                        if (availabilitiesFrom[dateToISOString(roundDay(date))] === false) {
                            return [false, 'is-booked', translate('datepicker.not-bookable')];
                        }

                        // not loaded yet
                        if (!loadedFrom
                            || !loadedTo
                            || roundDay(new Date(date.getTime() + MIN_DURATION)).getTime() > loadedTo.getTime()
                            || date.getTime() < loadedFrom.getTime() ) {
                            return [false, 'is-loading', translate('datepicker.is-loading')];
                        }

                        return getDatepickerCellSettings({date, from, to, availabilities: availabilitiesFrom, isArrival: true});


                    }
                });

                setUIOptions($to, {
                    onChangeMonthYear: function (year, month) {
                        loadMonthIfNeeded({year, month});
                    },
                    beforeShowDay: function (date) {
                        date = localDateToUTCDate(date);

                        // not available
                        if (availabilitiesTo[dateToISOString(roundDay(date))] === false) {
                            return [false, 'is-booked', translate('datepicker.not-bookable')];
                        }

                        // not loaded yet
                        if (!loadedFrom
                            || !loadedTo
                            || roundDay(new Date(date.getTime() - MIN_DURATION)).getTime() < loadedFrom.getTime()
                            || date.getTime() < loadedFrom.getTime() ) {
                            return [false, 'is-loading', translate('datepicker.is-loading')];
                        }

                        return getDatepickerCellSettings({date, from, to, availabilities: availabilitiesTo, isArrival: false})
                    }
                });
            } else {

                setUIOptions($from, {
                    beforeShowDay: function (date) {
                        date = localDateToUTCDate(date);

                        return getDatepickerCellSettings({date, from, to, isArrival: true});
                    }
                });

                setUIOptions($to, {
                    beforeShowDay: function (date) {
                        date = localDateToUTCDate(date);

                        return getDatepickerCellSettings({date, from, to, isArrival: false});
                    }
                });
            }
        }

        function loadMonthIfNeeded({year, month}) {
            let startOfNewMonth = new Date(Date.UTC(year, month));
            let endOfNewMonth = getLastOfMonth(startOfNewMonth);

            if (!loadedTo || !loadedFrom) {
                renderLoadingOverlay();

                loadAvailabilities(
                    getFirstOfMonth(roundDay(new Date(startOfNewMonth.getTime() - MIN_DURATION ))),
                    getLastOfMonth(roundDay(new Date(endOfNewMonth.getTime() + MIN_DURATION * 4)))
                );
            } else if (endOfNewMonth.getTime() + MIN_DURATION > loadedTo.getTime()) {
                renderLoadingOverlay();

                loadAvailabilities(loadedTo, getLastOfMonth(new Date(endOfNewMonth.getTime() + MIN_DURATION * 5)));
            } else if (startOfNewMonth.getTime() - MIN_DURATION < loadedFrom.getTime()) {
                renderLoadingOverlay();

                loadAvailabilities(getFirstOfMonth(new Date(startOfNewMonth.getTime() - MIN_DURATION * 5)), loadedFrom);
            }
        }

        let isLoading = false;
        function loadAvailabilities(from, to) {

            if (isLoading) { return }

            let loadingFrom, loadingTo;

            if (!loadedFrom
                || !loadedTo
                || from.getTime() < loadedFrom.getTime() && to.getTime() > loadedTo.getTime()) {
                loadingFrom = from;
                loadingTo = to;
            } else {
                if (from.getTime() < loadedFrom.getTime()) {
                    loadingFrom = from;
                    loadingTo = loadedFrom;
                } else if (to.getTime() > loadedTo.getTime()) {
                    loadingFrom = loadedTo;
                    loadingTo = to;
                }
            }

            if (loadingTo && loadingFrom) {
                isLoading = true;
                $.ajax(url, {
                    data: {
                        from: dateToISOString(loadingFrom),
                        to: dateToISOString(loadingTo),
                    },
                    dataType: 'JSON'
                }).then(response => {

                    isLoading = false;
                    if (response && response.success) {
                        if (response.occupiedDates) {
                            response.occupiedDates["from"].forEach(dateString => {
                                availabilitiesFrom[dateString] = false;
                            });
                            response.occupiedDates["to"].forEach(dateString => {
                                availabilitiesTo[dateString] = false;
                            });
                        }

                        loadedFrom = loadedFrom
                            ? new Date(Math.min(loadingFrom.getTime(), loadedFrom.getTime()))
                            : loadingFrom;
                        loadedTo = loadedTo
                            ? new Date(Math.max(loadingTo.getTime(), loadedTo.getTime()))
                            : loadingTo;

                        $('#ui-datepicker-div').removeClass('is-loading')
                            .find('.is-loading').removeClass('is-loading');


                        refreshCurrent();

                        // check if datepicker is currently open
                        // if it is open load the current month if needed
                        if ($.datepicker
                            && $.datepicker._curInst
                            && $.datepicker._curInst.input
                            && (
                                $.datepicker._curInst.input.closest($from).length
                                || $.datepicker._curInst.input.closest($to).length
                            )
                        ) {
                            loadMonthIfNeeded({
                                year: $.datepicker._curInst.drawYear,
                                month: $.datepicker._curInst.drawMonth
                            });
                        }
                    }

                }).catch((...params) => {
                    isLoading = false;
                    console.error(...params);
                });
            }
        }

        $(this).data('datepicker-range',{
            setAvailabilitiesUrl:function(newUrl) {
                hasAvailabilities = true;
                url = newUrl;

                loadedFrom = null;
                loadedTo = null;
                // availabilities = {};
                availabilitiesFrom = {};
                availabilitiesTo = {};

                onAvailabilityChange();
            }
        })


    });
}

function getFirstOfMonth(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth()))
}

function getLastOfMonth(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1) -  DAY_IN_MS)
}

function roundDay(date) {
    date = new Date(date.getTime() + HOUR_IN_MS);
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()))
}

function isValidRange({from, to, availabilities}) {
    from = roundDay(from);
    to = roundDay(to);

    let diffInMS = to.getTime() - from.getTime();
    if (diffInMS < MIN_DURATION) {
        return false;
    }

    for (var i = 0; i < Math.round((to.getTime() - from.getTime()) / DAY_IN_MS); i++) {
        if (availabilities[dateToISOString(roundDay(new Date(from.getTime() + i * DAY_IN_MS)))] === false) {
            return false;
        }
    }

    return true;
}

function calculateMaxToDate({from, availabilities}) {
    from = roundDay(from);

    for (var i = MIN_DURATION_DAYS; i < MAX_DURATION_DAYS; i++) {
        let nextDay = roundDay(new Date(from.getTime() + (i+1) * DAY_IN_MS));
        if (availabilities[dateToISOString(nextDay)] === false) {
            return nextDay;
        }
    }

    return roundDay(new Date(from.getTime() + MAX_DURATION));
}

function renderLoadingOverlay() {
    let timeout = setTimeout(function () {
        // timeout is used to postpone the markup changes
        // because jquery ui datepicker is refreshed after onChangeMonthYear is called
        // which cases would remove the newly appended markup

        $('#ui-datepicker-div')
            .addClass('is-loading')
            .append(`
                <div class="loading-overlay mt-5">
                    <div class="pt-5">
                        <div class="loading-spinner" aria-label="{{ 'content.loading'|trans }}">
                            <i class="icon icon-clock-only-v2"></i>
                            <i class="icon icon-clock-only-v2"></i>
                        
                            <i class="icon icon-animated-signet_clock_hands"></i>
                        </div>
                
                        <div class="mt-3">
                            ${translate('loading')}        
                        </div>
                    </div>
                </div>
            `);
        clearTimeout(timeout)
    }, 0);
}

function getDatepickerCellSettings({date, from, to, availabilities, isArrival}) {
    let cssClasses = [];
    let texts = [];
    let isAllowed = true;

    if (availabilities) {
        if (!_config.blockedDatesCalendar) {
            for (var i = 1; i < MIN_DURATION_DAYS; i++) {
                if (isArrival) {
                    if (availabilities[dateToISOString(roundDay(localDateToUTCDate(new Date(date.getTime() + i * DAY_IN_MS))))] === false) {

                        if (_config.lang && _config.lang === 'de') {
                            texts.push('Keine Anreise möglich');
                        } else {
                            texts.push('No Arrival');
                        }
                        isAllowed = false;
                        break;
                    }
                } else if (availabilities[dateToISOString(roundDay(localDateToUTCDate(new Date(date.getTime() - i * DAY_IN_MS))))] === false) {
                    if (_config.lang && _config.lang === 'de') {
                        texts.push('Keine Abreise möglich');
                    } else {
                        texts.push('No Departure');
                    }
                    isAllowed = false;
                    break;
                }
            }
        }

    }

    // is arrival
    if (date.getTime() === from.getTime()) {
        cssClasses.push('is-arrival');
        if (_config.lang && _config.lang === 'de') {
            texts.push('Anreise');
        } else {
            texts.push('Arrival');
        }
    }

    // is departure
    if (date.getTime() === to.getTime()) {
        cssClasses.push('is-departure');
        if (_config.lang && _config.lang === 'de') {
            texts.push('Abreise');
        } else {
            texts.push('Departure');
        }
    }

    // is in between
    if (date.getTime() > from.getTime() && date.getTime() < to.getTime()) {
        cssClasses.push('is-in-range');
    }

    return [isAllowed, cssClasses.join(' '), texts.join(', ')];
}